import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-card rounded-lg shadow p-6 mt-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "font-medium" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "text-sm text-muted-foreground"
}
const _hoisted_8 = {
  key: 1,
  class: "text-sm text-muted-foreground"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 0,
  class: "mt-4 p-3 bg-red-100 text-red-700 rounded-md"
}
const _hoisted_14 = {
  key: 1,
  class: "mt-4 p-3 bg-green-100 text-green-700 rounded-md"
}
const _hoisted_15 = {
  key: 0,
  class: "mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "text-xl font-semibold mb-4" }, "Microsoft Integration", -1)),
    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-muted-foreground mb-4" }, " Connect your Microsoft account to enable access to SharePoint and other Microsoft services ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"w-10 h-10 flex-shrink-0 mr-3\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 23\" class=\"w-full h-full\"><rect x=\"1\" y=\"1\" width=\"10\" height=\"10\" fill=\"#f25022\"></rect><rect x=\"12\" y=\"1\" width=\"10\" height=\"10\" fill=\"#7fba00\"></rect><rect x=\"1\" y=\"12\" width=\"10\" height=\"10\" fill=\"#00a4ef\"></rect><rect x=\"12\" y=\"12\" width=\"10\" height=\"10\" fill=\"#ffb900\"></rect></svg></div>", 1)),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_4, [
            (_ctx.isConnected)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Microsoft Account Connected"))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "Connect Microsoft Account"))
          ]),
          (_ctx.isConnected)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Connected as " + _toDisplayString(_ctx.microsoftEmail || 'Unknown'), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_8, " Enable SharePoint access and file management "))
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMicrosoftConnection && _ctx.toggleMicrosoftConnection(...args))),
        class: _normalizeClass([
          'px-4 py-2 rounded-md transition-colors',
          _ctx.isConnected
            ? 'bg-destructive text-destructive-foreground hover:bg-destructive/90'
            : 'bg-primary text-primary-foreground hover:bg-primary/90'
        ]),
        disabled: _ctx.loading || !_ctx.userIdAvailable
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[3] || (_cache[3] = _createElementVNode("svg", {
                class: "animate-spin -ml-1 mr-2 h-4 w-4",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("circle", {
                  class: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  "stroke-width": "4"
                }),
                _createElementVNode("path", {
                  class: "opacity-75",
                  fill: "currentColor",
                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                })
              ], -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.isConnected ? 'Disconnecting...' : 'Connecting...'), 1)
            ]))
          : (!_ctx.userIdAvailable)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Loading user data..."))
            : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.isConnected ? 'Disconnect' : 'Connect'), 1))
      ], 10, _hoisted_9)
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    (_ctx.successMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createTextVNode(_toDisplayString(_ctx.successMessage) + " ", 1),
          (_ctx.successMessage.includes('neuem Tab'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refreshStatus && _ctx.refreshStatus(...args))),
                  class: "px-3 py-1 bg-green-600 text-white rounded text-sm hover:bg-green-700"
                }, " Verbindungsstatus prüfen ")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}